const CONSTANTS = module.exports = {};

CONSTANTS.BACKOFFICE_ROLES = {
    ADMIN: 'admin', // access to everything (the only role that allows to view/edit/create backoffice users)
    RESERVATIONS_MANAGER: 'reservations_manager', // access to reservations data (reservations management page, reservations view/edit/create, csvs, etc), no access to users/companies data
    ACCOUNT_MANAGER: 'account_manager', // access to users/companies data (view/edit/create), no access to reservations data
    MATCHER: 'matcher', // access to room mapping functionalities
    ROOM_TRADER: 'room_trader', // access to repricer functionalities
    FINANCE_MANAGER: 'finance_manager' // access to credit line
};